module.exports = __webpack_public_path__ + "static/media/how_to_invite.924cfdf1.png";